import React, { useMemo, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import styles from './Bongo.module.css';

const BONGO_ASSETS = {
  neutral: '/assets/bongo/body/bongo-neutral.png',
  happy: '/assets/bongo/body/bongo-happy.png',
  success: '/assets/bongo/body/bongo-happy.png',
  encouragement: '/assets/bongo/body/bongo-neutral.png'
};

const SIZE_CLASSES = {
  small: styles.small,
  medium: styles.medium,
  large: styles.large
};

export default function Bongo({ mood = 'neutral', size = 'medium', className = '', idle = false }) {
  const reduceMotion = useReducedMotion();
  const safeMood = BONGO_ASSETS[mood] ? mood : 'neutral';
  const safeSize = SIZE_CLASSES[size] ? size : 'medium';
  const [hasImageError, setHasImageError] = useState(false);
  const moodClassName = {
    neutral: styles.moodNeutral,
    happy: styles.moodHappy,
    success: styles.moodSuccess,
    encouragement: styles.moodEncouragement,
  }[safeMood];
  const fallbackFontSize = useMemo(() => {
    if (safeSize === 'small') return 32;
    if (safeSize === 'large') return 72;
    return 52;
  }, [safeSize]);

  const shouldAnimate = idle && !reduceMotion;

  return (
    <motion.div
      animate={shouldAnimate ? { scale: [1, 1.012, 1] } : undefined}
      transition={shouldAnimate ? { duration: 3.2, ease: 'easeInOut', repeat: Infinity } : undefined}
      whileTap={{ scale: 0.985 }}
      className={`${styles.root} ${className}`.trim()}
    >
      {hasImageError ? (
        <span
          role="img"
          aria-label="Bongo fallback"
          style={{ fontSize: `${fallbackFontSize}px`, lineHeight: 1 }}
        >
          🦊
        </span>
      ) : (
        <img
          src={BONGO_ASSETS[safeMood]}
          alt={safeMood === 'happy' ? 'Bongo happy mascot' : 'Bongo neutral mascot'}
          className={`${styles.image} ${SIZE_CLASSES[safeSize]} ${moodClassName}`}
          width={256}
          height={256}
          loading="lazy"
          decoding="async"
          onError={() => setHasImageError(true)}
        />
      )}
    </motion.div>
  );
}
